import {
  BaseLayout,
  GetInitialPropsWithPrevious,
  NextI18nConfig,
  NextI18nServiceOptions,
  NextI18nService,
} from '@scorenco/next';
import { GetServerSideProps, GetStaticProps } from 'next';

type TournoisLayoutOptions = {
  i18n?: NextI18nServiceOptions;
};

export const TournoisLayout = {
  ...BaseLayout,
  appEnhancer: NextI18nService.appEnhancer,
  init: (options: NextI18nConfig) => NextI18nService.init(options),
  buildGetInitialProps: (
    options?: TournoisLayoutOptions,
    list?: GetInitialPropsWithPrevious[]
  ) =>
    BaseLayout.buildGetInitialProps([
      NextI18nService.getInitalPropsFn(options?.i18n),
      ...(list || []),
    ]),
  buildGetServerSideProps: (
    options?: TournoisLayoutOptions,
    list?: GetServerSideProps[]
  ) =>
    BaseLayout.buildGetServerSideProps([
      NextI18nService.getServerSidePropsFn(options?.i18n),
      ...(list || []),
    ]),
  buildGetStaticProps: (
    options?: TournoisLayoutOptions,
    list?: GetStaticProps[]
  ) =>
    BaseLayout.buildGetStaticProps([
      NextI18nService.getStaticPropsFn(options?.i18n),
      ...(list || []),
    ]),
};
